const { v4: uuidv4 } = require('uuid')

const API_URL = 'https://api.funo.ai'
const CLOUDFRONT_DOMAIN = 'https://uploads.funo.ai'

export const uploadToS3 = async (file, type) => {
  const s3Key = `admin/${uuidv4()}`

  const extensionMap = {
    img: ['png', 'jpg', 'jpeg', 'webp'],
    gif: ['gif'],
    video: ['mp4', 'webm'],
  }

  // Get the actual file extension from the file type or name
  let fileExtension = file.type.split('/')[1] || 'bin'

  // For webp files, ensure we use the correct extension
  if (file.type === 'image/webp') {
    fileExtension = 'webp'
  } else if (file.type === 'video/webm') {
    fileExtension = 'webm'
  } else if (file.type === 'image/gif') {
    fileExtension = 'gif'
  } else if (file.type === 'video/mp4') {
    fileExtension = 'mp4'
  } else if (file.type.startsWith('image/')) {
    // For other image types, use the detected extension
    fileExtension = file.type.split('/')[1]
  } else if (file.type.startsWith('video/')) {
    // For other video types, use the detected extension
    fileExtension = file.type.split('/')[1]
  }

  // Validate that the extension is allowed for the given type
  if (extensionMap[type] && !extensionMap[type].includes(fileExtension)) {
    console.warn(
      `File extension ${fileExtension} not in allowed list for type ${type}. Using detected extension anyway.`,
    )
  }
  const fullFileName = `${s3Key}.${fileExtension}`
  const presignUrl = `${API_URL}/get-upload-url?filename=${fullFileName}&contentType=${file.type}`

  const token = localStorage.getItem('token')?.replace(/^"|"$/g, '')
  const res = await fetch(presignUrl, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  })
  if (!res.ok) {
    throw new Error('presigned url failed')
  }

  const data = await res.json()
  if (!data.url) {
    throw new Error('presigned url missing ')
  }

  const uploadRes = await fetch(data.url, {
    method: 'PUT',
    headers: {
      'Content-Type': file.type,
    },
    body: file,
  })

  if (!uploadRes.ok) {
    throw new Error('file failed')
  }

  const cleanDomain = CLOUDFRONT_DOMAIN.replace(/\/$/, '').replace(/^https?:\/\//, '')
  return `https://${cleanDomain}/${fullFileName}`
}
